var googleMapInit;

(function ($) {

	const selectors = {
		wrapper: '[data-google-map]',
		map: '[data-google-map-map]',
	}


	googleMapInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new GoogleMap(el);
		});
	}

	class GoogleMap {
		constructor(element) {

			this.$wrap = $(element);
			this.$map = $(selectors.map, this.$wrap);

			if (this.$map.length) {
				this.init();
			}

		}
		init() {

			const self = this;

			self.max_zoom = 15;

			var latLng = {
				lat: parseFloat(self.$map.attr('data-lat')),
				lng: parseFloat(self.$map.attr('data-lng'))
			};


			// Create gerenic map.
			var mapArgs = {
				zoom: self.$map.data('zoom') || self.max_zoom,
				maxZoom: self.max_zoom,
				// center: latLng,
				mapTypeId: self.$map.attr('data-type') || 'roadmap',
				styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }]
			};

			self.googleMap = new google.maps.Map(self.$map[0], mapArgs);

			var bounds = new google.maps.LatLngBounds();

			if ($('#inwestycja-location', self.$wrap).length) {

				var latLng = new google.maps.LatLng(
					parseFloat($('#inwestycja-location', self.$wrap).attr('data-lat')),
					parseFloat($('#inwestycja-location', self.$wrap).attr('data-lng'))
				);

				self.investmentMarker = new google.maps.Marker({
					position: latLng,
					map: self.googleMap,
					cursor: 'default',
					icon: {
						url: wp_params.theme_url + '/assets/img/map-marker-investment.svg?v=1.1',
						size: new google.maps.Size(261, 134),
						anchor: new google.maps.Point(52, 110)
					}
				});

				bounds.extend(latLng);
			}


			if ($('#sprzedaz-location', self.$wrap).length) {

				var latLng = new google.maps.LatLng(
					parseFloat($('#sprzedaz-location', self.$wrap).attr('data-lat')),
					parseFloat($('#sprzedaz-location', self.$wrap).attr('data-lng'))
				);

				self.sprzedazMarker = new google.maps.Marker({
					position: latLng,
					map: self.googleMap,
					cursor: 'default',
					icon: {
						url: wp_params.theme_url + '/assets/img/map-marker-sprzedaz.svg',
						size: new google.maps.Size(261, 134),
						anchor: new google.maps.Point(52, 110)
					}
				});

				bounds.extend(latLng);

			}


			self.googleMap.fitBounds(bounds); //auto-zoom
			self.googleMap.panToBounds(bounds); //auto-center

			var zoom = self.googleMap.getZoom();
			self.googleMap.setZoom(zoom > self.max_zoom ? self.max_zoom : zoom);

			// self.googleMap.panBy(90, 0);

		}
	}

})(jQuery);

export default googleMapInit;